/* Copyright (c) 2018 Scaper */

import { UserInfo } from "@firebase/auth-types";
import * as React from "react";
import { CloseButton } from "../modal/closeButton";

interface IProps {
    userInfo: UserInfo;
}

export class Payment extends React.PureComponent<IProps, {}> {
    public render() {
        const { userInfo } = this.props;
        const { displayName } = userInfo;
        return (
            <>
                <h2>
                    Payment Methods

                    <CloseButton />
                </h2>

                <div className="divider"></div>

                <div className="section">
                    Payment information for {displayName}.
                </div>
            </>
        );
    }
}
